import { Route, Routes, Navigate, useParams } from "react-router-dom"
import { Error404 } from "source/shared/components"
import { Household } from "./Household"
import { HouseholdsIndex } from "./HouseholdsIndex"
import { HouseholdsNew } from "./HouseholdsNew"
import { HouseholdMemberEdit } from "./HouseholdMemberEdit"
import { HouseholdMemberNew } from "./HouseholdMemberNew"
import { useFlipperFeatureEnabled } from "source/shared/flipperFeatures"

export function Households() {
  const customFieldsEnabled = useFlipperFeatureEnabled("ROLLOUT_custom_fields")

  function HouseholdRedirect() {
    const { householdId } = useParams()
    if (customFieldsEnabled) {
      return (
        <Navigate
          to={`/me/profile-and-household?household=${householdId}`}
          replace
        />
      )
    }
    return <Household />
  }

  return (
    <Routes>
      <Route path="/" element={<HouseholdsIndex />} />
      <Route path="/new" element={<HouseholdsNew />} />
      <Route path="/:householdId" element={<HouseholdRedirect />} />
      <Route
        path="/:householdId/household-members/:householdMemberId/contact-and-info/edit"
        element={<HouseholdMemberEdit />}
      />
      <Route
        path="/:householdId/household-members/new"
        element={<HouseholdMemberNew />}
      />
      <Route path="*" element={<Error404 />} />
    </Routes>
  )
}
